import { i18n } from "@lingui/core";
import { AuthActionEnum } from "@mobsuccess-devops/react-shared/auth";
import { axiosPost } from "@mobsuccess-devops/react-shared/fetch";
import { useToasters } from "@mobsuccess-devops/react-ui/Toaster/use-toasters";
import { useMutation } from "@tanstack/react-query";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useResetPassword() {
  const { toast } = useToasters();
  return useMutation({
    mutationKey: [AuthActionEnum.ResetPassword],
    async mutationFn(options: {
      email: string;
      code: string;
      password: string;
    }) {
      await axiosPost({
        entity: "auth",
        verb: "resetpassword",
        token: null,
        params: {
          email: options.email,
          code: options.code,
          password: options.password,
        },
      });
    },
    onSuccess() {
      toast.success({
        title: i18n._("src.public.auth.reset-password-success.title"),
        description: i18n._(
          "src.public.auth.reset-password-success.description",
        ),
      });
    },
    onError() {
      toast.error({
        title: i18n._("src.public.auth.reset-password-error.title"),
        description: i18n._("src.public.auth.reset-password-error.description"),
      });
    },
  });
}
